// JavaScript Document
//"esversion : 6";
import { config } from "../game"
export default class EndScene extends Phaser.Scene {
  constructor() {
    super({ key: 'EndScene' })
  }
  //initialize:
  
  //init(data) {
    //this.FinalScore= data.score;
  //}
  preload() {
    //const testDiv3= document.getElementById('testDiv');
    //this.FinalScore= testDiv3.innerText;
   //getRecordVal();
   //alert(this.FinalScore + config.width);//------------------------------------------------------
   
  }

  create () {
    console.log("this is:", this);
    this.gameover= this.add.text(config.width / 2, 100, `Game Over`, {
      color: '#ff0',
      fontFamily: 'Tahoma',
      fontSize: 40,
      resolution: 2
    }).setOrigin(0.5, 0.5)
    console.log("已經執行到此");
    this.restart = this.add.text(config.width / 2, 400, `restart`, {
      color: '#fff',
      fontFamily: 'Tahoma',
      fontSize: 40,
      resolution: 2
    }).setOrigin(0.5, 0.5).setInteractive({useHandCursor: true})
      .on('pointerup',() => {
        this.scene.start('MainScene')
      }, this )
      .on('pointerover', () => {
        this.restart.alpha  = 0.5
      }, )
      .on('pointerout', () => {
        this.restart.alpha  = 1
      })

      const testDiv3= document.getElementById('testDiv');
      this.FinalScore= testDiv3.innerText;
      console.log(this.FinalScore + config.width);

    this.add.text(config.width / 2, 200, `SCORE: ${this.FinalScore}`, {
      color: '#fff',
      fontFamily: 'Tahoma',
      fontSize: 40,
      resolution: 2
    }).setOrigin(0.5, 0.5)

    this.tweens.add({
      targets: this.gameover,
      y: { from: 0, to: 100 },
      ease: 'Bounce.easeOut',
      duration: 1000,
      repeat: 0,
      yoyo: false
    })
  }


}

//function getRecordVal(aaa){
  //const testDiv3= document.getElementById('testDiv');
  //aaa= testDiv3.innerText;
//}

